import { factory, getResponseCamelization } from '@repo-level/core-front';
import { CMS_URL, isCMSV3 } from 'helpers/conf';
import type { CMSApiBase, CMSArrayBase, CMSImageBase } from './base';
import { buildCmsUrl, getResponseCMS } from './base';

export interface Method extends CMSArrayBase {
  name: string;
  type: string;
  fee: string;
  processingTime: string;
  limitsPerTransaction: string;
  image: CMSImageBase;
  imageGrayscale: CMSImageBase;
  registrationForm: boolean;
  lobbySlider: boolean;
  paymentMethodsPage: boolean;
}

export interface MethodSection {
  methods: Method[];
}

export interface PaymentMethodsApi extends CMSApiBase {
  title: string;
  text: string;
  depositMethods: MethodSection;
  withdrawMethods: MethodSection;
}

export const paymentMethodsV3 = factory(
  (r) => (lang: string) =>
    r<PaymentMethodsApi>('get', `${CMS_URL}/payment-methods?_locale=${lang}`)
);

export const paymentMethodsV4 = factory(
  (r) => (lang: string) =>
    r<PaymentMethodsApi>(
      'get',
      buildCmsUrl({
        path: 'payment-method',
        lang,
        additionalParams: { populate: 'deep' },
      }),
      undefined,
      { transformResponse: [getResponseCamelization(), getResponseCMS] }
    )
);

export const paymentMethods = isCMSV3 ? paymentMethodsV3 : paymentMethodsV4;
